import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RolesService } from '../../../services/roles.service';
import { Observable } from 'rxjs';
import { AssignRolePermissionRequestDTO, PermissionDTO } from '../../../interfaces/permission.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-assign-role-permissions-modal',
  templateUrl: './assign-role-permissions-modal.component.html',
  styleUrls: ['./assign-role-permissions-modal.component.scss']
})
export class AssignRolePermissionsModalComponent implements OnInit{

  public permissions$: Observable<Array<PermissionDTO>>;
  public formGroup: FormGroup;

  constructor(public dialogRef: MatDialogRef<AssignRolePermissionsModalComponent> ,
    @Inject(MAT_DIALOG_DATA) public data: number, 
    private fb: FormBuilder,
    private roleService: RolesService){
      this.permissions$ = new Observable<Array<PermissionDTO>>;
      this.formGroup = this.fb.group({
        roleId: [this.data],
        permissions: [null, Validators.required ]
      });
  }

  ngOnInit(): void {
      this.getUnassignedPermissions();
  }

  close(){
    this.dialogRef.close();
  }

  getUnassignedPermissions() {
    this.permissions$ = this.roleService.getUnassignedPermissionsRole(this.data);
  }

  submit() {
    Swal.fire({
      title: 'Agregando permisos',
      icon: 'info',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        this.sendAssignPermissionsRole();
      }
    }) 
  }

  sendAssignPermissionsRole(){
    const { roleId, permissions } = this.formGroup.value;
    const request: AssignRolePermissionRequestDTO = {
      roleId: roleId,
      permissionsId: permissions
    };
    this.roleService.assignRolePermissions(request)
    .subscribe({
      next: (res) => {
        Swal.fire({
          text: res.resultMessage,
          allowOutsideClick: false,
          icon: 'success',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        }).then((r) => {
          this.dialogRef.close(true);
        })
      },
      error: (err) => {
        Swal.fire({
          title: 'Error',
          text: err.error.resultMessage,
          icon: 'error',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar',
        })
      }
    });
  }
}
